<h1 mat-dialog-title>Artikel reservieren{{data.article ? ': ' + data.article.title + ' (ID: ' + data.article.internalId + ')' : ''}}</h1>

<div mat-dialog-content>
  <knust-article-storage-locations [filterForId]="storageLocationId"></knust-article-storage-locations>
</div>
